import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('planPackageModules.routes.index'),
        name: 'planPackageModules.index',
        component: () =>
            import(
                /* webpackChunkName: "plan-packages" */ '@/views/planPackages/modules/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('planPackages.breadcrumbs.index'),
                    to: { name: 'planPackages.index' },
                    disable: false,
                },
                {
                    text: i18n.t('planPackages.breadcrumbs.modules'),
                    to: { name: 'planPackageModules.index' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('planPackageModules.routes.edit'),
        name: 'planPackageModules.edit',
        component: () =>
            import(
                /* webpackChunkName: "plan-packages" */ '@/views/planPackages/modules/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('planPackages.breadcrumbs.index'),
                    to: { name: 'planPackages.index' },
                    disable: false,
                },
                {
                    text: i18n.t('planPackages.breadcrumbs.modules'),
                    to: { name: 'planPackageModules.index' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('planPackageModules.routes.create'),
        name: 'planPackageModules.create',
        component: () =>
            import(
                /* webpackChunkName: "plan-packages" */ '@/views/planPackages/modules/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('planPackages.breadcrumbs.index'),
                    to: { name: 'planPackages.index' },
                    disable: false,
                },
                {
                    text: i18n.t('planPackages.breadcrumbs.modules'),
                    to: { name: 'planPackageModules.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: { name: 'planPackageModules.create' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('planPackageModules.routes.batch-create'),
        name: 'planPackageModules.batchCreate',
        component: () =>
            import(
                /* webpackChunkName: "plan-packages" */ '@/views/planPackages/modules/BatchCreate.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('planPackages.breadcrumbs.index'),
                    to: { name: 'planPackages.index' },
                    disable: false,
                },
                {
                    text: i18n.t('planPackages.breadcrumbs.modules'),
                    to: { name: 'planPackageModules.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.breadcrumb.create'),
                    to: { name: 'planPackageModules.batchCreate' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
